module.exports = __webpack_public_path__ + "img/1.b4822021.jpg";